import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faFolderXmark } from '@fortawesome/pro-solid-svg-icons/faFolderXmark';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { IpmRqKeys } from '@ukpostbox/client-data/lib/Wrappers/ReactQuery/CacheKeys';
import {
	Button,
	DropdownMenu,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	Tooltip,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { useMailbox } from '../../Providers/NewMailboxProvider';
import { TagMenu } from '../../../_Global/Components/Tags/Menus/TagMenu';
import MailActionButtons from '../MailActionButtons';
import MailboxFolders from '../MailboxFolders';
import { SelectedMailToolbarType } from './ToolbarTypes';
import { useMailboxesStore } from '../../Providers/Stores/MailboxesStore';

function SelectedMailToolbar(props: SelectedMailToolbarType) {
	const { t } = useTranslation();

	const { parsedFilters, UpdateMailTags, ActionItem, RemoveItemsFromFolder } = useMailbox();

	const mailBoxInfo = useMailboxesStore((state) => state.mailBoxInfo);
	return (
		<StackHorizontal gap={FlexGap.ExtraSmall} justify={FlexJustify.Start}>
			{props.showCustomFolderRemove && (
				<Tooltip content={t('customFolders.actions.removeFromFolder')}>
					<Button
						title={t('customFolders.actions.removeFromFolder')}
						icon={faFolderXmark}
						iconOnly
						squared
						onClick={() => RemoveItemsFromFolder(mailBoxInfo.customFolderId as number)}
					/>
				</Tooltip>
			)}

			<div>
				<DropdownMenu
					title='Selected Mailboxes Folders'
					trigger={
						<Tooltip content={t('mailboxes.actions.moveToFolder')}>
							<Button
								title={t('mailboxes.actions.moveToFolder')}
								extraClass='mailbox-folder-menu'
								showArrow
								icon={faFolder}
								iconOnly
								squared
								onClick={() => null}
							/>
						</Tooltip>
					}
				>
					<MailboxFolders mailItemContext />
				</DropdownMenu>
			</div>

			{props.data && (
				<>
					<div>
						<DropdownMenu
							title='Selected Mailboxes Tags'
							trigger={
								<Tooltip content={t('mailboxes.actions.tagItems')}>
									<Button
										title={t('mailboxes.actions.tagItems')}
										extraClass='mailbox-tag-menu'
										showArrow
										icon={faTag}
										iconOnly
										squared
										onClick={() => null}
									/>
								</Tooltip>
							}
						>
							<TagMenu
								data={props.data}
								dataKey={[IpmRqKeys.MAIL_BOX_KEY, parsedFilters]}
								updateCallback={(e: any, b: boolean) => UpdateMailTags(e, b)}
							/>
						</DropdownMenu>
					</div>

					<MailActionButtons
						iconsOnly
						actionCallback={(value: number) => (props.data ? ActionItem(props.data, value) : undefined)}
					/>
				</>
			)}
		</StackHorizontal>
	);
}

export { SelectedMailToolbar };
